import { render, staticRenderFns } from "./AssetReviewStepConfirm.vue?vue&type=template&id=7beffb2d&"
import script from "./AssetReviewStepConfirm.vue?vue&type=script&lang=js&"
export * from "./AssetReviewStepConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AssetReviewStepConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7beffb2d')) {
      api.createRecord('7beffb2d', component.options)
    } else {
      api.reload('7beffb2d', component.options)
    }
    module.hot.accept("./AssetReviewStepConfirm.vue?vue&type=template&id=7beffb2d&", function () {
      api.rerender('7beffb2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/AssetReview/ReviewSteps/AssetReviewStepConfirm.vue"
export default component.exports